<template>
  <a-form-item
    :label="props.label"
    :name="props.name"
    :rules="[
      {
        required: props.required,
        message: props.message,
      },
    ]"
  >
    <VueDatePicker
      class="vue-date-picker"
      v-model="date"
      @update:modelValue="onChange"
      :placeholder="props.placeholder"
      :format-locale="th"
      :enable-time-picker="false"
      :format="format"
      ignore-time-validation
      auto-apply
      :min-date="minDate"
      :max-date="maxDate"
      :disabled="props.disabled"
      :teleport-center="props.teleportCenter"
      @open="openDate"
      @closed="closedDate"
    >
      <template
        #month-year="{
          month,
          year,
          months,
          years,
          updateMonthYear,
          handleMonthYearChange,
        }"
      >
        <div class="flex flex-row items-center justify-between w-full">
          <LeftOutlined @click="handleMonthYearChange(false)" />
          <div class="flex gap-4">
            <select
              :value="month"
              class="text-lg"
              @change="updateMonth($event, updateMonthYear, year)"
            >
              <option v-for="m in months" :key="m.value" :value="m.value">
                {{ m.text }}
              </option>
            </select>
            <select
              class="select-input"
              :value="year"
              @change="updateYear($event, updateMonthYear, month)"
            >
              <option v-for="y in years" :key="y.value" :value="y.value">
                {{ parseInt(y.text) + 543 }}
              </option>
            </select>
          </div>
          <RightOutlined @click="handleMonthYearChange(true)" />
        </div>
      </template>
    </VueDatePicker>
  </a-form-item>
</template>

<script lang="ts" setup>
import { BaseDatePicker2Props } from "@/components/formControls/type";
import { monthThai } from "@/utils/constants";
import { LeftOutlined, RightOutlined } from "@ant-design/icons-vue";
import { th } from "date-fns/locale";
import dayjs from "dayjs";
import $ from "jquery";
import { computed, ref, watch } from "vue";

const props = withDefaults(defineProps<BaseDatePicker2Props>(), {
  placeholder: "กรุณาเลือก",
  required: false,
  message: "",
  disabled: false,
  teleportCenter: false,
});

const emit = defineEmits(["update:modelValue"]);

const date = ref<Date>();

const onChange = (date: Date | null) => {
  emit("update:modelValue", date ? dayjs(date) : undefined);
};

const format = (date: Date) => {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  return `${day} ${monthThai[month]} ${year + 543}`;
};

watch(
  () => props.modelValue,
  (modelValue) => {
    if (date.value !== modelValue?.toDate()) {
      date.value = modelValue?.toDate();
    }
  },
  { immediate: true },
);

const minDate = computed(() =>
  props.minDate ? new Date(props.minDate?.toDate()) : undefined,
);

const maxDate = computed(() => {
  return props.maxDate ? new Date(props.maxDate?.toDate()) : new Date();
});

const updateMonth = (event: any, updateMonthYear: Function, year: number) => {
  updateMonthYear(+event.target.value, year);
};

const updateYear = (event: any, updateMonthYear: Function, month: number) => {
  updateMonthYear(month, +event.target.value);
};

const openDate = () => {
  if (props.targetElement) {
    $(`${props.targetElement} .ant-table-content`).addClass("overflow-inherit");
  }
};

const closedDate = () => {
  if (props.targetElement) {
    $(`${props.targetElement} .ant-table-content`).removeClass(
      "overflow-inherit",
    );
  }
};
</script>

<style scoped></style>
